import { httpClientWincheck } from "./http-client";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { TicketCheckRequest, TicketCheckResponse } from "@/lotteries/model/ticket-check/ticket-check";

export const getLotteryMaxDuration = async (lottery: Lottery) => {
    const response = await httpClientWincheck.get<{ maxDuration: number }>(`/max-duration/${lottery}`);
    return response.data.maxDuration;
};

export const fetchTicketCheckResult = async (lottery: Lottery, request: TicketCheckRequest) => {
    const response = await httpClientWincheck.post<TicketCheckResponse>(`/ticket-check/${lottery}`, request);
    return response.data;
};
